var map = {
	"./AddButton.svg": 2362,
	"./Eye.svg": 786,
	"./Trash.svg": 1599,
	"./add.svg": 2952,
	"./call.svg": 9213,
	"./category.svg": 7121,
	"./close.svg": 6677,
	"./edit-square.svg": 7982,
	"./locPlacePhone.svg": 1665,
	"./menu/active/notif-active.svg": 4077,
	"./menu/active/place-active.svg": 1027,
	"./menu/active/users-active.svg": 5953,
	"./menu/notif.svg": 2091,
	"./menu/place.svg": 7053,
	"./menu/users.svg": 3769,
	"./sms.svg": 114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3424;